import React from "react";

import { TestWrapper } from "@ui/Atoms/TestWrapper";
import { Text } from "@ui/Atoms/Text";

import { useBreakpoint } from "@hooks/useBreakpoint";

import type { RowProps } from "./Table.types";
import * as Styled from "./Table.styled";

export const Row: React.FC<RowProps> = props => {
  const { mobile } = useBreakpoint("v1");

  return (
    <TestWrapper testId={props.testId}>
      <Styled.ContentRow>
        <td colSpan={mobile ? 2 : 1}>
          <Text $style="regular_14">{props.heading}</Text>

          {!!props.details && <Text $style="regular_12">{props.details}</Text>}
        </td>
        <Styled.ExtraCell />
        <Text as="td" $style="regular_16">
          {props.value}
        </Text>
        <td />
      </Styled.ContentRow>
    </TestWrapper>
  );
};
